"use client";

import { createContext } from "react";

/** A message prefix chosen when a dialog opens (Skuffesager's Vis interesse names the listing); ContactForm puts it in
 *  its hidden `messageTextPre` in place of the configured one. Absent everywhere else, so forms are unchanged. */
export const FormMessagePrefixContext = createContext<string | undefined>(
  undefined,
);
